import React, { useEffect, useRef, useState } from "react";
import { Collapse, Button, Card, Spinner } from "react-bootstrap";
import { Row, Col, Form } from "react-bootstrap";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { toast } from "react-toastify";
import CustomTextInput from "./SimpleInputComponents/simpleTextInput.jsx";
import { callApi } from "../constant/callApi.js";
import CryptoJS from "crypto-js";
import Preloader from "../components/preloader";
import { IoMdCheckmark } from "react-icons/io";
import { FaBook } from "react-icons/fa";
import logo from "../assets/images/logo.png";

import ReCAPTCHA from "react-google-recaptcha";
import { Value } from "sass";

const ApplicantRegistration = () => {
  const [userInputs, setUserInputs] = useState({});
  const [open1, setOpen1] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [mailOtpResponse, setMailOtpResponse] = useState({});
  const [phoneOtpResponse, setPhoneOtpResponse] = useState({});
  const [loading, setLoading] = useState(false);
  const [SendMobileBtnLoading, setSendMobileBtnLoading] = useState(false);
  const [confirmMObileOtpLoading, setConfirmMObileOtpLoading] = useState(false);
  const [mobileOtpConformation, setOtpMobileConfirmation] = useState(false);
  const [emailOtpLoading, setEmailOtpLoading] = useState(false);
  const [emailOtpConformation, setEmailOtpConformation] = useState(false);
  const [emailConformationLoading, setEmailConFormationLoading] =
    useState(false);

  const [isChecked, setIsChecked] = useState(false);
  const [reCAPTCHAtoken, setReCAPTCHAToken] = useState("");
  const [verified, setVerified] = useState(false);
  const [logoSize, setLogoSize] = useState("75%");
  const [scroll, setScroll] = useState(0);

  const inputRefs = useRef({});
  const navigate = useNavigate();
  const location = useLocation();

  // SAS Token for blob storage access - loaded from environment variable with fallback
  const sasToken =
    process.env.REACT_APP_SAS_TOKEN ||
    "sp=racwd&st=2025-11-05T04:53:36Z&se=2027-01-01T13:08:36Z&spr=https&sv=2024-11-04&sr=c&sig=hQ%2BFCGxIoCVboFWlW7S%2Bp2BYyN2m%2FfAIYtu41mcHoPI%3D";

  // User Manual PDF URL with SAS token
  const userManualUrl = `https://odishminingblobsg.blob.core.windows.net/blobcontainer-sg/blobcontainer-sg/User%20Manual/User%20Manual%20ORMS-Candidate%20(V-final1).pdf?${sasToken}`;

  // Function to open user manual in new tab
  const openUserManual = () => {
    if (userManualUrl) {
      window.open(userManualUrl, "_blank", "noopener,noreferrer");
    } else {
      toast.warning("User manual not available.");
    }
  };

  // Handle scroll for header
  useEffect(() => {
    document.addEventListener("scroll", () => {
      const scrollCheck = window.scrollY > 100;
      if (scrollCheck !== scroll) {
        setScroll(scrollCheck);
      }
    });
  }, [scroll]);

  // Handle logo size on resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1200) {
        setLogoSize("75%");
      } else if (window.innerWidth > 768) {
        setLogoSize("50%");
      } else {
        setLogoSize("30%");
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Set initial size

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    console.log({ userInputs });
  }, [userInputs]);
  const setUserInputFn = (e) => {
    const { name, value } = e.target;

    console.log(name, value, "name-- is here");
    setUserInputs((prevInputs) => ({
      ...prevInputs,
      [name]: {
        ...prevInputs[name],

        value: value,
      },
    }));
  };
  const handleEmailOtp = () => {};
  const handlePhoneOtp = () => {};
  function updateInputState(name, value, errors, touched) {
    console.log(name, "name");
    setUserInputs((prevInputs) => {
      const newInputs = { ...prevInputs };

      if (!newInputs[name]) {
        newInputs[name] = { value: "", errors: {} };
      }

      newInputs[name] = {
        ...newInputs[name],
        value,
        errors,
        touched,
      };

      return newInputs;
    });
  }
  function validateEmail(value) {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(value);
  }

  function validateAlphaSpace(value) {
    const regex = /^[a-zA-Z ]+$/;
    return regex.test(value);
  }
  function validate10Digit(value) {
    // Regex to check for exactly 10 digits
    const regex = /^\d{10}$/;
    return regex.test(value);
  }
  function valid10RegistrationNo(value) {
    console.log(value, "not_AlphaSpace");
    const regex = /^(?=.*\S)[a-zA-Z0-9]+$/;
    console.log(regex.test(value));
    return regex.test(value);
  }
  function validate6Digit(value) {
    // Regex to check for exactly 10 digits
    const regex = /^\d{6}$/;
    return regex.test(value);
  }
  function validDob(value) {
    if (!value) {
      console.log("Date of Birth is required.");
      return false; // Required field is empty
    }

    // Additional checks can be added here to validate the date format
    const date = new Date(value);
    return date instanceof Date && !isNaN(date); // Validates that it's a proper date
  }

  const checkForInputError = (e) => {
    // console.log(, "called");
    const { name, value, required } = e.target;
    const trimmedValue = value;
    console.log(name, "required");

    if (!required && (trimmedValue === "" || trimmedValue == null)) {
      // No validation for non-required empty values
      console.log("StepsAre there");
      updateInputState(name, trimmedValue, {}, true);
    } else {
      const errors = {};

      switch (name) {
        case "fullName":
          if (!validateAlphaSpace(trimmedValue)) {
            errors["not_AlphaSpace"] =
              "Only Alphabet and Spaces are allowed in this input.";
          }
          break;

        case "confirmFullName":
          if (!validateAlphaSpace(trimmedValue)) {
            errors["confirm_FullName"] =
              "Only Alphabet and Spaces are allowed in this input.";
          }
          const fullNameValue = userInputs?.["fullName"]?.value?.trim() || "";
          const confirmFullNameValue = trimmedValue?.trim() || "";
          if (confirmFullNameValue !== fullNameValue) {
            errors["not_matchFullName"] = "Candidate full name does not match.";
          }
          break;
        case "phoneNumber":
          if (!validate10Digit(trimmedValue)) {
            errors["not_10digit"] = "Only 10 Digits allowed in this input.";
          }
          break;
        case "confirmMobileNumber":
          if (!validate10Digit(trimmedValue)) {
            errors["not_10digit"] = "Only 10 Digits allowed in this input.";
          }
          const phoneNumberValue = userInputs?.["phoneNumber"]?.value?.trim() || "";
          const confirmMobileNumberValue = trimmedValue?.trim() || "";
          if (confirmMobileNumberValue !== phoneNumberValue) {
            errors["notMatching"] = "Mobile number does not match.";
          }
          break;
        case "emailId":
          if (!validateEmail(trimmedValue)) {
            errors["not_email"] = "Please Enter a valid Email Id.";
          }
          break;
        case "confirmEmailId":
          if (!validateEmail(trimmedValue)) {
            errors["not_email"] = "Please Enter a valid Email Id.";
          }
          const emailIdValue = userInputs?.["emailId"]?.value?.trim() || "";
          const confirmEmailIdValue = trimmedValue?.trim() || "";
          if (confirmEmailIdValue !== emailIdValue) {
            errors["notMatching"] = "Email Id does not match.";
          }
          break;
        case "mobileOtp":
          if (!validate6Digit(trimmedValue)) {
            errors["not_email"] = "Only 6 Digits allowed in this input.";
          }
          break;
        case "emailOtp":
          if (!validate6Digit(trimmedValue)) {
            errors["not_email"] = "Only 6 Digits allowed in this input.";
          }
          break;
        case "registrationNo":
          console.log(trimmedValue, "trimmedValueof10th");
          if (!valid10RegistrationNo(trimmedValue)) {
            console.log("Step1");
            errors["not_registrationNo"] =
              "Only alphanumeric characters are allowed.";
            console.log("Step2");
          }
          break;

        case "confirm10registrationNo":
          if (!valid10RegistrationNo(trimmedValue)) {
            errors["confirm_10registration"] =
              "Only alphanumeric characters are allowed.";
          }
          // Use strict comparison and trim both values for accurate matching
          const registrationNoValue = userInputs["registrationNo"]?.value?.trim() || "";
          const confirmRegistrationNoValue = trimmedValue?.trim() || "";
          if (confirmRegistrationNoValue !== registrationNoValue) {
            errors["confirm10thDoesNotMatch"] =
              "Both 10th Certificate Registration No./Enrollment No./Unique Id and Confirm 10th Certificate Registration No./Enrollment No./Unique Id should be same.";
          }
          break;
        case "dob":
          if (!validDob(trimmedValue)) {
            errors["not_dob"] = "Date of Birth is required.";
          }
          break;

        case "confirmDob":
          {
            if (!validDob(trimmedValue)) {
              errors["not_valid_confirmDob"] =
                "Confirm Date of Birth is required.";
            }
            const dobValue = userInputs["dob"]?.value?.trim() || "";
            const confirmDobValue = trimmedValue?.trim() || "";
            if (confirmDobValue !== dobValue) {
              errors["not_dateOfBirthmatch"] =
                "Date of Birth And Confirm Date of Birth should be same";
            }
          }
          break;

        default:
          break;
      }

      console.log(errors, "here is errors");
      updateInputState(name, trimmedValue, errors, true);
    }
  };
  const [buttonHandlers, setButtonHandlers] = useState({});
  useEffect(() => {
    if (buttonHandlers.sendMobileOtp) {
      setButtonHandlers((prv) => ({ ...prv, ["sendMobileOtp"]: false }));
      sendPhoneOtpFinalFunction();
    }
    if (buttonHandlers.verifyMobileOtp) {
      setButtonHandlers((prv) => ({ ...prv, ["verifyMobileOtp"]: false }));
      verifyOtpFinalFunction();
    }
    if (buttonHandlers.sendMailOtp) {
      setButtonHandlers((prv) => ({ ...prv, ["sendMailOtp"]: false }));
      sendMailFinalFunction();
    }
    if (buttonHandlers.verifyEmailOtp) {
      setButtonHandlers((prv) => ({ ...prv, ["verifyEmailOtp"]: false }));
      verifyOtpMailFunction();
    }
  }, [userInputs, buttonHandlers]);
  const sendPhoneOtp = async () => {
    await inputRefs.current["fullName"].focus();
    await inputRefs.current["fullName"].blur();

    await inputRefs.current["confirmFullName"].focus();
    await inputRefs.current["confirmFullName"].blur();
    await inputRefs?.current?.["phoneNumber"]?.focus();
    await inputRefs?.current?.["phoneNumber"]?.blur();
    await inputRefs?.current?.["confirmMobileNumber"]?.focus();
    await inputRefs?.current?.["confirmMobileNumber"]?.blur();
    await inputRefs?.current?.["registrationNo"]?.focus();
    await inputRefs?.current?.["registrationNo"]?.blur();
    await inputRefs?.current?.["dob"]?.focus();
    await inputRefs?.current?.["confirmDob"]?.focus();
    await inputRefs.current?.["confirmDob"]?.blur();
    await inputRefs.current?.["confirm10registrationNo"].focus();
    await inputRefs.current?.["confirm10registrationNo"].blur();
    await inputRefs?.current?.["dob"]?.blur();

    setButtonHandlers((prv) => ({ ...prv, ["sendMobileOtp"]: true }));
  };
  const sendPhoneOtpFinalFunction = async () => {
    let errors = [
      ...Object.keys(userInputs["fullName"].errors),
      ...Object.keys(userInputs["confirmMobileNumber"].errors),
      ...Object.keys(userInputs["phoneNumber"].errors),
    ];
    console.log({ errors });

    if (errors.length === 0) {
      try {
        setSendMobileBtnLoading(true);
        setOtpMobileConfirmation(false);
        let config = {
          method: "post",
          url: "Portal/portal/generatePhoneOtpForPortalRegistration",
          data: {
            phoneNumber: userInputs?.["phoneNumber"]?.value,
          },
        };

        const response = await callApi(config);

        // Check if the response code is 201
        if (response?.data?.code == 201) {
          setSendMobileBtnLoading(false);
          toast.success("OTP sent successfully", { autoClose: 3000 });
        }
      } catch (error) {
        console.log(error, "here is error");
        toast.error(error.message, { autoClose: 2000 });
      }
    }
  };

  const verifyPhoneOtp = async () => {
    await inputRefs.current["fullName"].focus();
    await inputRefs.current["fullName"].blur();
    await inputRefs.current["confirmFullName"].focus();
    await inputRefs.current["confirmFullName"].blur();
    await inputRefs?.current?.["phoneNumber"]?.focus();
    await inputRefs?.current?.["phoneNumber"]?.blur();
    await inputRefs?.current?.["confirmMobileNumber"]?.focus();
    await inputRefs?.current?.["confirmMobileNumber"]?.blur();
    await inputRefs?.current?.["mobileOtp"]?.focus();
    await inputRefs?.current?.["mobileOtp"]?.blur();
    await inputRefs?.current?.["registrationNo"]?.focus();
    await inputRefs?.current?.["registrationNo"]?.blur();
    await inputRefs?.current?.["dob"]?.focus();
    await inputRefs?.current?.["dob"]?.blur();
    await inputRefs?.current?.["confirmDob"]?.focus();
    await inputRefs.current?.["confirmDob"]?.blur();
    await inputRefs.current?.["confirm10registrationNo"].focus();
    await inputRefs.current?.["confirm10registrationNo"].blur();
    setButtonHandlers((prv) => ({ ...prv, ["verifyMobileOtp"]: true }));
  };
  const verifyOtpFinalFunction = async () => {
    console.log("btn input", { userInputs });
    let errors = [
      ...Object.keys(userInputs["fullName"].errors),
      ...Object.keys(userInputs["confirmMobileNumber"].errors),
      ...Object.keys(userInputs["phoneNumber"].errors),
      ...Object.keys(userInputs["mobileOtp"].errors),
    ];
    console.log({ errors });
    if (errors.length == 0) {
      const hashedOtp = CryptoJS.SHA256(
        userInputs?.["mobileOtp"]?.value
      ).toString(CryptoJS.enc.Hex);

      try {
        setConfirmMObileOtpLoading(true);
        let config = {
          method: "post",
          url: "Portal/portal/verifyOTPForPhone",
          data: {
            phoneNumber: userInputs?.["phoneNumber"]?.value,
            otp: hashedOtp,
          },
        };
        let phoneOtpRes = await callApi(config);
        setPhoneOtpResponse(phoneOtpRes?.data);
        if (phoneOtpRes?.data?.code == 201) {
          toast.success("OTP for Phone No. is verified successfully", {
            autoClose: 3000,
          });
          setOtpMobileConfirmation(true);
          setConfirmMObileOtpLoading(false);
        } else {
          setConfirmMObileOtpLoading(false);
          toast.error("Please enter a valid OTP");
        }
      } catch (error) {
        console.log(error, "here is error");
        toast.error(error.message, { autoClose: 2000 });
      }
    }
  };

  const sendMailOtp = async () => {
    await inputRefs?.current["fullName"].focus();
    await inputRefs?.current["fullName"].blur();
    await inputRefs?.current["confirmFullName"].focus();
    await inputRefs.current["confirmFullName"].blur();
    await inputRefs?.current?.["emailId"]?.focus();
    await inputRefs?.current?.["emailId"]?.blur();
    await inputRefs?.current?.["confirmEmailId"]?.focus();
    await inputRefs?.current?.["confirmEmailId"]?.blur();
    await inputRefs?.current?.["registrationNo"]?.focus();
    await inputRefs?.current?.["registrationNo"]?.blur();
    await inputRefs?.current?.["dob"]?.focus();
    await inputRefs?.current?.["dob"]?.blur();
    await inputRefs?.current?.["confirmDob"]?.focus();
    await inputRefs.current?.["confirmDob"]?.blur();
    await inputRefs.current?.["confirm10registrationNo"].focus();
    await inputRefs.current?.["confirm10registrationNo"].blur();
    setButtonHandlers((prv) => ({ ...prv, ["sendMailOtp"]: true }));
  };
  const sendMailFinalFunction = async () => {
    console.log("btn input", { userInputs });
    let errors = [
      ...Object.keys(userInputs["fullName"].errors),
      ...Object.keys(userInputs["confirmEmailId"].errors),
      ...Object.keys(userInputs["emailId"].errors),
    ];
    console.log({ errors });
    if (errors.length == 0) {
      try {
        setEmailOtpLoading(true);
        setEmailOtpConformation(false);
        let config = {
          method: "post",
          url: "Portal/portal/generateMailOtpForPortalRegistration",
          data: {
            email: userInputs?.["emailId"]?.value,
          },
        };
        const response = await callApi(config);
        if (response?.data?.code == 201) {
          setEmailOtpLoading(false);
          toast.success("OTP sent successfully", { autoClose: 3000 });
        } else {
          setEmailOtpLoading(false);
        }
      } catch (error) {
        console.log(error, "here is error");
        toast.error(error.message, { autoClose: 2000 });
      }
    }
  };
  const verifyMailOtp = async () => {
    await inputRefs.current["fullName"].focus();
    await inputRefs.current["fullName"].blur();
    await inputRefs.current["confirmFullName"].focus();
    await inputRefs.current["confirmFullName"].blur();
    await inputRefs?.current?.["emailId"]?.focus();
    await inputRefs?.current?.["emailId"]?.blur();
    await inputRefs?.current?.["confirmEmailId"]?.focus();
    await inputRefs?.current?.["confirmEmailId"]?.blur();
    await inputRefs?.current?.["emailOtp"]?.focus();
    await inputRefs?.current?.["emailOtp"]?.blur();
    await inputRefs?.current?.["registrationNo"]?.focus();
    await inputRefs?.current?.["registrationNo"]?.blur();
    await inputRefs?.current?.["dob"]?.focus();
    await inputRefs?.current?.["dob"]?.blur();
    await inputRefs?.current?.["confirmDob"]?.focus();
    await inputRefs.current?.["confirmDob"]?.blur();
    await inputRefs.current?.["confirm10registrationNo"].focus();
    await inputRefs.current?.["confirm10registrationNo"].blur();
    setButtonHandlers((prv) => ({ ...prv, ["verifyEmailOtp"]: true }));
  };
  const verifyOtpMailFunction = async () => {
    let errors = [
      ...Object.keys(userInputs["fullName"].errors),
      ...Object.keys(userInputs["emailId"].errors),
      ...Object.keys(userInputs["confirmEmailId"].errors),
      ...Object.keys(userInputs["emailOtp"].errors),
    ];
    if (errors.length == 0) {
      const hashedOtp = CryptoJS.SHA256(
        userInputs?.["emailOtp"]?.value
      ).toString(CryptoJS.enc.Hex);

      try {
        setEmailConFormationLoading(true);
        let config = {
          method: "post",
          url: "Portal/portal/verifyOTPForMail",
          data: {
            email: userInputs?.["emailId"]?.value,
            emailOtp: hashedOtp,
          },
        };
        const responseMailOtp = await callApi(config);
        setMailOtpResponse(responseMailOtp?.data);
        if (responseMailOtp?.data?.code == 201) {
          toast.success("OTP for Email is verified successfully", {
            autoClose: 3000,
          });
          setEmailOtpConformation(true);
          setEmailConFormationLoading(false);
        } else {
          setEmailConFormationLoading(false);
          toast.error("Please enter a valid OTP");
        }
      } catch (error) {
        console.log(error, "here is error");
        toast.error(error.message, { autoClose: 2000 });
      }
    }
  };

  useEffect(() => {
    console.log({ phoneOtpResponse });
    console.log({ mailOtpResponse });
  }, [mailOtpResponse, phoneOtpResponse]);

  const registerUserCheck = async () => {
    // Trigger validation for all fields
    await inputRefs?.current?.["fullName"]?.focus();
    await inputRefs?.current?.["fullName"]?.blur();
    await inputRefs.current["confirmFullName"]?.focus();
    await inputRefs.current["confirmFullName"]?.blur();
    await inputRefs?.current?.["phoneNumber"]?.focus();
    await inputRefs?.current?.["phoneNumber"]?.blur();
    await inputRefs?.current?.["confirmMobileNumber"]?.focus();
    await inputRefs?.current?.["confirmMobileNumber"]?.blur();
    await inputRefs?.current?.["emailId"]?.focus();
    await inputRefs?.current?.["emailId"]?.blur();
    await inputRefs?.current?.["confirmEmailId"]?.focus();
    await inputRefs?.current?.["confirmEmailId"]?.blur();
    await inputRefs?.current?.["emailOtp"]?.focus();
    await inputRefs?.current?.["emailOtp"]?.blur();
    await inputRefs?.current?.["mobileOtp"]?.focus();
    await inputRefs?.current?.["mobileOtp"]?.blur();
    await inputRefs?.current?.["registrationNo"]?.focus();
    await inputRefs?.current?.["registrationNo"]?.blur();
    await inputRefs?.current?.["dob"]?.focus();
    await inputRefs?.current?.["dob"]?.blur();
    await inputRefs?.current?.["confirmDob"]?.focus();
    await inputRefs.current?.["confirmDob"]?.blur();
    await inputRefs.current?.["confirm10registrationNo"]?.focus();
    await inputRefs.current?.["confirm10registrationNo"]?.blur();

    // Wait for state to update after blur events
    await new Promise(resolve => setTimeout(resolve, 200));

    // Collect all errors from required fields
    const requiredFields = [
      "fullName",
      "confirmFullName",
      "phoneNumber",
      "confirmMobileNumber",
      "emailId",
      "confirmEmailId",
      "emailOtp",
      "mobileOtp",
      "registrationNo",
      "confirm10registrationNo",
      "dob",
      "confirmDob"
    ];

    const allErrors = [];
    const missingFields = [];
    
    requiredFields.forEach(fieldName => {
      const field = userInputs[fieldName];
      
      // Check if field is empty
      if (!field?.value || (typeof field.value === 'string' && field.value.trim() === "")) {
        missingFields.push(fieldName);
      }
      
      // Check for validation errors
      if (field?.errors && Object.keys(field.errors).length > 0) {
        allErrors.push(...Object.values(field.errors));
      }
    });

    // Check if there are missing required fields
    if (missingFields.length > 0) {
      toast.error(`Please fill all required fields: ${missingFields.join(", ")}`, {
        autoClose: 5000
      });
      return;
    }

    // Check if there are any validation errors
    if (allErrors.length > 0) {
      const firstError = allErrors[0];
      toast.error(firstError, {
        autoClose: 5000
      });
      return;
    }

    // Check OTP verification
    if (mailOtpResponse?.code == 201 && phoneOtpResponse?.code == 201) {
      registerUser();
    } else {
      toast.warning(
        "Kindly complete the form to verify your mobile number and email address for registration.",
        { autoClose: 5000 }
      );
    }
  };

  // Register function

  const registerUser = async () => {
    if (!isChecked) {
      toast.warn("Kindly complete the declarartion for registration.", {
        autoClose: 5000,
      });
      return;
    }
    if (!verified) {
      toast.warn("Kindly verify the Captcha for registration.", {
        autoClose: 5000,
      });
      return;
    }
    try {
      setLoading(true); // Set loading to true before starting the API call
      let config = {
        method: "post",
        url: "Portal/portal/register",
        data: {
          emailId: userInputs?.["emailId"]?.value,
          metricRegistration: userInputs?.["registrationNo"]?.value,
          phoneNumber: userInputs?.["phoneNumber"]?.value,
          fullName: userInputs?.["fullName"]?.value,
          DateOfBirth: userInputs?.["dob"]?.value,
          emailOtpId: mailOtpResponse?.data?.otpIdentification,
          phoneOtpId: phoneOtpResponse?.data?.otpIdentification,
          reCAPTCHAtoken,
          registrationDeclarationStatus: isChecked,
        },
      };

      const responseRegister = await callApi(config);
      if (responseRegister?.data?.code === 201) {
        toast.success(responseRegister?.data?.message, { autoClose: 1000 });

        navigate("/login");
      } else {
        toast.warning(responseRegister?.data?.message, { autoClose: 5000 });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false); // Set loading to false after the API call completes
    }
  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  function onChange(value) {
    console.log("Captcha value:", value);
    setReCAPTCHAToken(value);
    setVerified(true);
  }

  return (
    <>
      {loading ? (
        <Preloader />
      ) : (
        <>
          {/* OMC Logo Header */}
          <header
            id="header"
            className={`header header-default ${scroll ? "is-fixed is-small" : ""}`}
          >
            <div className="tf-container ct2">
              <div className="row">
                <div className="col-md-12">
                  <div className="sticky-area-wrap">
                    <div className="header-ct-left">
                      <div id="logo" className="logo">
                        <Link to="/login">
                          <img
                            className="site-logo"
                            id="trans-logo"
                            src={logo}
                            alt="OMC Logo"
                            style={{ maxWidth: logoSize, height: "auto" }}
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>

          <div className="registrationFormMain">
            <Card className="registrationFont job-registration-card">
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span>Registration</span>
                <Button
                  variant="primary"
                  size="sm"
                  onClick={openUserManual}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    backgroundColor: "#921d1e",
                    color: "#ffffff",
                    border: "none",
                    fontSize: "13px",
                    padding: "6px 12px",
                    borderRadius: "5px",
                    fontWeight: "500",
                    cursor: "pointer",
                  }}
                >
                  <FaBook
                    style={{ fontSize: "14px", color: "#ffffff" }}
                  />
                  <span className="d-none d-md-inline">
                    User Manual
                  </span>
                </Button>
              </div>
            </Card>
          <div className="formContainerStyle">
            <div className="jobRegistrationCard-main">
              <Card className="p-3 mt-3 mb-1 jobRegistrationCard ">
                <div className="job-registration-instruction">
                  <h5 className="registrationFontHead mt-1 job-registration-title">
                    Instructions:
                  </h5>
                  <Button
                    variant="link"
                    onClick={() => setOpen1(!open1)}
                    aria-controls="instructions-collapse"
                    aria-expanded={open1}
                    className="dropdown-btn"
                  >
                    {open1 ? "-" : "+"}
                  </Button>
                </div>
                <Collapse in={open1}>
                  <div className="collapse-one">
                    {/* <p className="applicationform-text">
                      <strong className="registrationFont-head">
                        Application Form:
                      </strong>
                    </p>
                    <strong>
                      <p className="registrationFont mt-2">
                        Important Information
                      </p>
                    </strong> */}
                    <p className="registrationFont mt-2">
                      <strong>
                        Read the below information carefully, before proceeding
                        further :
                      </strong>
                    </p>
                    <p className="registrationFont mt-2">
                      <strong>
                        Fields marked with{" "}
                        <strong className="text-danger">*</strong> are
                        mandatory.
                      </strong>
                    </p>
                    <ol className="headList mt-2">
                      <li
                        style={{ color: "brown", fontWeight: "bolder" }}
                        className="registrationFont"
                      >
                        <strong>
                          1. Please ensure correctness while furnishing the
                          information or details.
                        </strong>
                      </li>
                      <li
                        style={{ color: "brown", fontWeight: "bolder" }}
                        className="registrationFont"
                      >
                        <strong>
                          2. Candidates must fill in the required details below
                          to complete the registration process.
                        </strong>
                      </li>
                      <li
                        className="registrationFont"
                        style={{ color: "brown", fontWeight: "bolder" }}
                      >
                        <strong>
                          3. Upon successful registration, you will receive a
                          confirmation email and SMS.
                        </strong>
                      </li>
                      <li
                        className="registrationFont"
                        style={{ color: "brown", fontWeight: "bolder" }}
                      >
                        <strong>
                          4. The Candidates are required to provide accurate information, in this page, including the following, as the same cannot be corrected at the later stage.
                          <ol className="headList">
                            <li className="registrationFont">a) Full Name</li>
                            <li className="registrationFont">
                              b) Mobile Number
                            </li>
                            <li className="registrationFont">
                              c) Email Address
                            </li>
                            <li className="registrationFont">
                              d) 10th Certificate No. / Registration No. /
                              Enrollment No. / Unique ID.
                            </li>
                            <li className="registrationFont">
                              e) Date of Birth
                            </li>
                          </ol>
                        </strong>
                      </li>
                      <li
                        className="registrationFont"
                        style={{ color: "brown", fontWeight: "bolder" }}
                      >
                        <strong>
                          5. Registered users can log in using their Mobile
                          Number or Email ID by entering the OTP received on the
                          same.
                        </strong>
                      </li>
                      <li
                        className="registrationFont"
                        style={{ color: "brown", fontWeight: "bolder" }}
                      >
                        <strong>
                          6. For any assistance, you may contact the Helpdesk at
                          0674-2377400/0674-2377401 between 10:00 AM and 5:30 PM
                          on working days.
                        </strong>
                      </li>
                    </ol>
                  </div>
                </Collapse>
              </Card>
              <Card className="p-3 mt-3 mb-5 jobRegistrationCard">
                <div className="job-registration-instruction">
                  <h5 className="registrationFontHead mt-1 job-registration-title">
                    Basic Details
                  </h5>
                  <Button
                    variant="link"
                    onClick={() => setOpen2(!open2)}
                    aria-controls="instructions-collapse"
                    aria-expanded={open2}
                    className="dropdown-btn"
                  >
                    {open2 ? "-" : "+"}
                  </Button>
                </div>
                <div className="noteStyle fw-bolder" style={{ color: "brown" }}>
                  NOTE: AS RECORDED IN 10th OR EQUIVALENT EXAM
                </div>
                <Collapse in={open2}>
                  <Form>
                    <Row className="mt-1">
                      <Col xs={12} md={4} className="register-col-data">
                        <CustomTextInput
                          className="register-main-placeholder registerPlaceHolder"
                          id="fullName"
                          type="password"
                          label="Enter Candidate's Full Name"
                          required
                          placeholder="Candidate's  Full Name"
                          name="fullName"
                          touched={userInputs?.["fullName"]?.touched}
                          value={userInputs?.["fullName"]?.value.toUpperCase()}
                          onChange={(e) => {
                            setUserInputFn(e);
                            userInputs?.["fullName"]?.touched &&
                              checkForInputError(e);
                          }}
                          onBlur={(e) => checkForInputError(e)}
                          errors={userInputs?.["fullName"]?.errors}
                          ref={(el) => (inputRefs.current["fullName"] = el)}
                          onCopy={(e) => e.preventDefault()} // Prevents copy
                          onPaste={(e) => e.preventDefault()} // Prevents paste
                          onCut={(e) => e.preventDefault()}
                        />
                      </Col>

                      <Col xs={12} md={4} className="register-col-data">
                        <CustomTextInput
                          className="register-main-placeholder registerPlaceHolder"
                          id="confirmFullName"
                          type="text"
                          label="Confirm Candidate's Full Name"
                          required
                          placeholder="Confirm Candidate's Full Name"
                          name="confirmFullName"
                          touched={userInputs?.["confirmFullName"]?.touched}
                          value={userInputs?.[
                            "confirmFullName"
                          ]?.value.toUpperCase()}
                          onChange={(e) => {
                            setUserInputFn(e);
                            userInputs?.["confirmFullName"]?.touched &&
                              checkForInputError(e);
                          }}
                          onBlur={(e) => checkForInputError(e)}
                          errors={userInputs?.["confirmFullName"]?.errors}
                          ref={(el) =>
                            (inputRefs.current["confirmFullName"] = el)
                          }
                          onCopy={(e) => e.preventDefault()} // Prevents copy
                          onPaste={(e) => e.preventDefault()} // Prevents paste
                          onCut={(e) => e.preventDefault()}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={4} className="register-col-data">
                        <CustomTextInput
                          className="register-main-placeholder registerPlaceHolder"
                          id="dob"
                          type="date"
                          label="Enter Candidate's Date of birth."
                          required
                          placeholder="Date of birth."
                          name="dob"
                          touched={userInputs?.["dob"]?.touched}
                          value={userInputs?.["dob"]?.value}
                          onChange={(e) => {
                            setUserInputFn(e);
                            userInputs?.["dob"]?.touched &&
                              checkForInputError(e);
                          }}
                          onBlur={(e) => checkForInputError(e)}
                          errors={userInputs?.["dob"]?.errors}
                          ref={(el) => (inputRefs.current["dob"] = el)}
                          onCopy={(e) => e.preventDefault()} // Prevents copy
                          onPaste={(e) => e.preventDefault()} // Prevents paste
                          onCut={(e) => e.preventDefault()}
                        />
                      </Col>
                      <Col xs={12} md={4} className="register-col-data">
                        <CustomTextInput
                          className="register-main-placeholder registerPlaceHolder"
                          id="confirmDob"
                          type="date"
                          label="Confirm Candidate's Date of birth"
                          required
                          placeholder="Date of birth."
                          name="confirmDob"
                          touched={userInputs?.["confirmDob"]?.touched}
                          value={userInputs?.["confirmDob"]?.value}
                          onChange={(e) => {
                            setUserInputFn(e);
                            userInputs?.["confirmDob"]?.touched &&
                              checkForInputError(e);
                          }}
                          onCopy={(e) => e.preventDefault()} // Prevents copy
                          onPaste={(e) => e.preventDefault()} // Prevents paste
                          onCut={(e) => e.preventDefault()}
                          onBlur={(e) => checkForInputError(e)}
                          errors={userInputs?.["confirmDob"]?.errors}
                          ref={(el) => (inputRefs.current["confirmDob"] = el)}
                        />
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col md={4} xs={12} className="register-col-data">
                        <CustomTextInput
                          className="register-main-placeholder"
                          id="registrationNo"
                          type="password"
                          label="10th Certificate No. / Registration No. / Enrollment No. / Unique ID."
                          required
                          placeholder="10th Certificate No. / Registration No. / Enrollment No. / Unique ID."
                          name="registrationNo"
                          touched={userInputs?.["registrationNo"]?.touched}
                          value={userInputs?.["registrationNo"]?.value}
                          onChange={(e) => {
                            setUserInputFn(e);
                            userInputs?.["registrationNo"]?.touched &&
                              checkForInputError(e);
                          }}
                          onBlur={(e) => checkForInputError(e)}
                          errors={userInputs?.["registrationNo"]?.errors}
                          ref={(el) =>
                            (inputRefs.current["registrationNo"] = el)
                          }
                          onCopy={(e) => e.preventDefault()} // Prevents copy
                          onPaste={(e) => e.preventDefault()} // Prevents paste
                          onCut={(e) => e.preventDefault()}
                        />
                      </Col>
                      <Col md={4} xs={12} className="register-col-data">
                        <CustomTextInput
                          className="register-main-placeholder"
                          id="confirm10registrationNo"
                          type="text"
                          label="Confirm 10th Certificate No. / Registration No. / Enrollment No. / Unique ID."
                          required
                          placeholder="Confirm 10th Certificate No. / Registration No. / Enrollment No. / Unique ID."
                          name="confirm10registrationNo"
                          touched={
                            userInputs?.["confirm10registrationNo"]?.touched
                          }
                          value={userInputs?.["confirm10registrationNo"]?.value}
                          onChange={(e) => {
                            setUserInputFn(e);
                            userInputs?.["confirm10registrationNo"]?.touched &&
                              checkForInputError(e);
                          }}
                          onBlur={(e) => checkForInputError(e)}
                          errors={
                            userInputs?.["confirm10registrationNo"]?.errors
                          }
                          ref={(el) =>
                            (inputRefs.current["confirm10registrationNo"] = el)
                          }
                          onCopy={(e) => e.preventDefault()} // Prevents copy
                          onPaste={(e) => e.preventDefault()} // Prevents paste
                          onCut={(e) => e.preventDefault()}
                        />
                      </Col>
                    </Row>
                    <div
                      className="noteStyle fw-bolder mt-3"
                      style={{ color: "brown" }}
                    >
                      NOTE: YOU ARE REQUIRED TO PROVIDE YOUR CORRECT MOBILE
                      NUMBER AND E-MAIL ADDRESS, AS ALL IMPORTANT COMMUNICATIONS
                      WILL BE SENT TO YOU USING THE SAME.
                    </div>
                    <Row className="mt-2">
                      <Col md={4} xs={12} className="register-col-data">
                        <CustomTextInput
                          className="register-main-placeholder"
                          id="phoneNumber"
                          label="Mobile Number"
                          type="password"
                          required
                          placeholder="Enter Mobile Number"
                          name="phoneNumber"
                          touched={userInputs?.["phoneNumber"]?.touched}
                          value={userInputs?.["phoneNumber"]?.value}
                          onChange={(e) => {
                            setUserInputFn(e);
                            userInputs?.["phoneNumber"]?.touched &&
                              checkForInputError(e);
                          }}
                          onBlur={(e) => checkForInputError(e)}
                          errors={userInputs?.["phoneNumber"]?.errors}
                          ref={(el) => (inputRefs.current["phoneNumber"] = el)}
                          onCopy={(e) => e.preventDefault()} // Prevents copy
                          onPaste={(e) => e.preventDefault()} // Prevents paste
                          onCut={(e) => e.preventDefault()}
                        />
                      </Col>
                      <Col md={4} xs={7} className="register-col-data">
                        <CustomTextInput
                          className="register-main-placeholder"
                          id="confirmMobileNumber"
                          label="Confirm Mobile Number"
                          type="number"
                          required
                          placeholder="Enter Confirm Mobile Number"
                          name="confirmMobileNumber"
                          touched={userInputs?.["confirmMobileNumber"]?.touched}
                          value={userInputs?.["confirmMobileNumber"]?.value}
                          onChange={(e) => {
                            setUserInputFn(e);
                            userInputs?.["confirmMobileNumber"]?.touched &&
                              checkForInputError(e);
                          }}
                          onBlur={(e) => checkForInputError(e)}
                          errors={userInputs?.["confirmMobileNumber"]?.errors}
                          ref={(el) =>
                            (inputRefs.current["confirmMobileNumber"] = el)
                          }
                          onCopy={(e) => e.preventDefault()} // Prevents copy
                          onPaste={(e) => e.preventDefault()} // Prevents paste
                          onCut={(e) => e.preventDefault()}
                        />
                      </Col>
                      <Col md={4} xs={5}>
                        <div className="mt-4">
                          <>
                            <Button
                              variant="primary"
                              className="sendOtp-btn"
                              disabled={SendMobileBtnLoading}
                              onClick={() => {
                                sendPhoneOtp();
                              }}
                            >
                              {!SendMobileBtnLoading ? (
                                "Send OTP "
                              ) : (
                                <Spinner size="sm"></Spinner>
                              )}
                            </Button>
                          </>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={4} xs={7} className="register-col-data">
                        <div className="position-relative">
                          <CustomTextInput
                            id="mobileOtp"
                            label="Mobile OTP"
                            type="text"
                            required
                            placeholder="Enter Mobile OTP"
                            name="mobileOtp"
                            touched={userInputs?.["mobileOtp"]?.touched}
                            onChange={(e) => {
                              setUserInputFn(e);
                              userInputs?.["mobileOtp"]?.touched &&
                                checkForInputError(e);
                            }}
                            onBlur={(e) => checkForInputError(e)}
                            value={userInputs?.["mobileOtp"]?.value}
                            errors={userInputs?.["mobileOtp"]?.errors}
                            ref={(el) => (inputRefs.current["mobileOtp"] = el)}
                            className="pr-4 register-main-placeholder"
                          />
                          {mobileOtpConformation && (
                            <IoMdCheckmark
                              className="position-absolute"
                              style={{
                                right: "10px",
                                top: "70%",
                                transform: "translateY(-50%)",
                                pointerEvents: "none",
                                color: "green",
                              }}
                            />
                          )}
                        </div>
                      </Col>

                      <Col md={6} xs={5}>
                        <div className="mt-4">
                          <Button
                            variant="primary"
                            className="sendOtp-btn"
                            disabled={confirmMObileOtpLoading}
                            onClick={() => verifyPhoneOtp()}
                          >
                            {!confirmMObileOtpLoading ? (
                              "Confirm OTP"
                            ) : (
                              <Spinner size="sm"></Spinner>
                            )}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col xs={12} md={4} className="register-col-data">
                        <CustomTextInput
                          className="register-main-placeholder"
                          id="emailId"
                          label="Email"
                          type="password"
                          required
                          placeholder="Enter Email"
                          name="emailId"
                          touched={userInputs?.["emailId"]?.touched}
                          value={userInputs?.["emailId"]?.value}
                          onChange={(e) => {
                            setUserInputFn(e);
                            userInputs?.["emailId"]?.touched &&
                              checkForInputError(e);
                          }}
                          onBlur={(e) => checkForInputError(e)}
                          errors={userInputs?.["emailId"]?.errors}
                          ref={(el) => (inputRefs.current["emailId"] = el)}
                        />
                      </Col>
                      <Col xs={7} md={4} className="register-col-data">
                        <CustomTextInput
                          className="register-main-placeholder"
                          id="confirmEmailId"
                          label="Confirm Email"
                          type="text"
                          required
                          placeholder="Enter Confirm Email"
                          name="confirmEmailId"
                          touched={userInputs?.["confirmEmailId"]?.touched}
                          value={userInputs?.["confirmEmailId"]?.value}
                          onChange={(e) => {
                            setUserInputFn(e);
                            checkForInputError(e);
                          }}
                          onBlur={(e) => checkForInputError(e)}
                          errors={userInputs?.["confirmEmailId"]?.errors}
                          ref={(el) =>
                            (inputRefs.current["confirmEmailId"] = el)
                          }
                        />
                      </Col>
                      <Col md={4} xs={5}>
                        <div className="mt-4">
                          <Button
                            variant="primary"
                            className="sendOtp-btn"
                            disabled={emailOtpLoading}
                            onClick={() => sendMailOtp()}
                          >
                            {!emailOtpLoading ? (
                              "Send OTP"
                            ) : (
                              <Spinner size="sm"></Spinner>
                            )}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={4} xs={7} className="register-col-data">
                        <div className="position-relative">
                          <CustomTextInput
                            className="register-main-placeholder"
                            id="emailOtp"
                            type="text"
                            label="Email OTP"
                            required
                            placeholder="Enter Confirm Email"
                            name="emailOtp"
                            touched={userInputs?.["emailOtp"]?.touched}
                            value={userInputs?.["emailOtp"]?.value}
                            onChange={(e) => {
                              setUserInputFn(e);
                              userInputs?.["emailOtp"]?.touched &&
                                checkForInputError(e);
                            }}
                            onBlur={(e) => checkForInputError(e)}
                            errors={userInputs?.["emailOtp"]?.errors}
                            ref={(el) => (inputRefs.current["emailOtp"] = el)}
                          />
                          {emailOtpConformation && (
                            <IoMdCheckmark
                              className="position-absolute"
                              style={{
                                right: "10px",
                                top: "70%",
                                transform: "translateY(-50%)",
                                pointerEvents: "none",
                                color: "green",
                              }}
                            />
                          )}
                        </div>
                      </Col>

                      <Col>
                        <div className="mt-4">
                          <Button
                            variant="primary"
                            disabled={emailConformationLoading}
                            className="sendOtp-btn"
                            onClick={() => verifyMailOtp()}
                          >
                            {!emailConformationLoading ? (
                              "Confirm OTP"
                            ) : (
                              <Spinner size="sm"></Spinner>
                            )}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </Collapse>

                <div style={{ display: "flex", marginTop: "30px" }}>
                  <input
                    type="checkbox"
                    id="declaration-checkbox"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                    style={{ marginRight: "10px", marginTop: "-23px" }}
                  />
                  <label
                    htmlFor="declaration-checkbox"
                    style={{
                      fontSize: "14px",
                      lineHeight: "1.5",
                      fontFamily: "'Roboto', sans-serif",
                      color: "black",
                    }}
                  >
                    <strong>
                      I hereby declare that the above information is true to the
                      best of my knowledge. I am aware that OMC will be sending
                      important information to my registered details. I declare
                      that I have referred to the advertisement and ensured my
                      eligibility before applying. I also declare that I have
                      read and understood all the instructions specified in the
                      advertisement and undertake to abide by same.
                    </strong>
                  </label>
                </div>

                <div className="mt-3">
                  <ReCAPTCHA
                                              sitekey="6LfxYy4sAAAAAAFt1KaKnkGZ2Xv1Co_AJsT5r7ak"
                    onChange={onChange}
                  />
                </div>
              </Card>
            </div>
          </div>
          <Card className="registrationFont registrationForm-bottom-card">
            <div>
              <Button
                variant="primary"
                className="registrationFont registrationForm-bottom-card-cancel-btn"
                onClick={() => navigate("/login")}
              >
                CANCEL
              </Button>
              <Button
                variant="primary"
                className="registrationFont registrationForm-bottom-card-submit-btn"
                onClick={registerUserCheck}
              >
                SUBMIT
              </Button>
            </div>
          </Card>
        </div>
        </>
      )}
    </>
  );
};
export default ApplicantRegistration;
